<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Lokasyon</label>
            <v-select-list placeholder="Lokasyon" v-model="location" label="LocationName" :options="locations"/>
        </div>                 
        <div class="col-md-6 mb-1">
            <label class="form-label">Ad</label>
            <input type="text" class="form-control" v-model="value.FirstName" placeholder="Ad">
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Soyad</label>
            <input type="text" class="form-control" v-model="value.LastName" placeholder="Soyad">
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">E-Posta</label>
            <input type="email" class="form-control" v-model="value.Email" placeholder="E-Posta">
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Dahili Numara</label>
            <input type="text" class="form-control" v-model="value.InternalNumber" placeholder="Dahili Numara">
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Cep Telefonu</label>
            <input type="text" class="form-control" v-model="value.MobilePhone" placeholder="Cep Telefonu">
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Telefon</label>
            <input type="text" class="form-control" v-model="value.Phone" placeholder="Telefon">
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İletişim Dili</label>
            <v-select-list placeholder="İletişim Dili" v-model="communicationLanguage" label="Name" :options="communicationLanguages"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Unvan</label>
            <v-select-list placeholder="Unvan" v-model="occupationTitle" label="Name" :options="occupationTitles"/>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox class="mb-50" id="OperationsManager" v-model="value.OperationsManager">Operasyon Sorumlusu</b-form-checkbox>
            <b-form-checkbox class="mb-50" id="AccountingManager" v-model="value.AccountingManager">Muhasebe Sorumlusu</b-form-checkbox>
            <b-form-checkbox class="mb-50" id="PurchasingManager" v-model="value.PurchasingManager">Satın Alma Sorumlusu</b-form-checkbox>
            <b-form-checkbox class="mb-50" id="FinanceOfficer" v-model="value.FinanceOfficer">Finans Sorumlusu</b-form-checkbox>
            <b-form-checkbox id="OfferOfficer" v-model="value.OfferOfficer">Teklif Sorumlusu</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import {BFormCheckbox} from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        locations:Array,
        communicationLanguages:Array,
        occupationTitles:Array,
        dummyLocation:{
            type:Boolean,
            default:false
        },
    },
    computed:{
        location:{
            get(){
                return  !this.dummyLocation 
                        ? this.locations.find(b=>b.Id==this.value.FirmLocationId)
                        : this.locations.find(b=>b.FirmLocationDummyId==this.value.FirmLocationDummyId)
            },
            set:function(value){
                if(!this.dummyLocation){
                    this.value.FirmLocation = value
                    this.value.FirmLocationId = value?.Id || this.value.FirmLocationId
                }else{
                    this.value.FirmLocationDummy = value
                    this.value.FirmLocationDummyId = value?.FirmLocationDummyId || this.value.FirmLocationDummyId
                }
                
            }
        },

        communicationLanguage:{
            get(){
                return this.communicationLanguages.find(b=>b.Id==this.value.CommunicationLanguageId)
                        
            },
            set:function(value){
                this.value.CommunicationLanguage = value
                this.value.CommunicationLanguageId = value?.Id || this.value.CommunicationLanguageId
            }
        },
        occupationTitle:{
            get(){
                return this.occupationTitles.find(b=>b.Id==this.value.OccupationTitleId)
            },
            set:function(value){
                this.value.OccupationTitle = value
                this.value.OccupationTitleId = value?.Id || this.value.OccupationTitleId
            }
        },

    }
}
</script>

<style>

</style>